import type { ReactNode } from 'react'
import { useHasCapability, useIsAdmin } from '@/hooks/use-permissions'

interface PermissionGateProps {
  /** Capability string to check (e.g., 'admin:users:manage') */
  capability?: string
  /** If true, only renders for GREYBULL_ADMIN */
  adminOnly?: boolean
  /** Content to render when permission is granted */
  children: ReactNode
  /** Optional fallback when permission is denied */
  fallback?: ReactNode
}

export function PermissionGate({
  capability,
  adminOnly,
  children,
  fallback = null,
}: PermissionGateProps) {
  const hasCapability = useHasCapability(capability ?? '')
  const isAdmin = useIsAdmin()

  if (adminOnly) {
    return isAdmin ? <>{children}</> : <>{fallback}</>
  }

  if (capability) {
    return hasCapability ? <>{children}</> : <>{fallback}</>
  }

  return <>{children}</>
}
